import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Academics = {
  __typename?: 'Academics';
  classRankPercentile?: Maybe<Scalars['Int']>;
  cumulativeGPA?: Maybe<Scalars['Float']>;
  testScores?: Maybe<Array<TestScores>>;
};

export type AcademicsInput = {
  classRankPercentile?: InputMaybe<Scalars['Int']>;
  cumulativeGPA?: InputMaybe<Scalars['Float']>;
  testScores?: InputMaybe<Array<TestScoresInput>>;
};

export type Affiliations = {
  __typename?: 'Affiliations';
  directRelation?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  indirectRelation?: Maybe<Scalars['String']>;
};

export type AffiliationsInput = {
  directRelation?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  indirectRelation?: InputMaybe<Scalars['String']>;
};

export type CollegeChoices = {
  __typename?: 'CollegeChoices';
  ceebCode?: Maybe<Scalars['String']>;
  ncesCode?: Maybe<Scalars['String']>;
  schoolAddress?: Maybe<SchoolAddress>;
  schoolName?: Maybe<Scalars['String']>;
  schoolType?: Maybe<Scalars['String']>;
};

export type CollegeChoicesInput = {
  ceebCode?: InputMaybe<Scalars['String']>;
  ncesCode?: InputMaybe<Scalars['String']>;
  schoolAddress?: InputMaybe<SchoolAddressInput>;
  schoolName?: InputMaybe<Scalars['String']>;
  schoolType?: InputMaybe<Scalars['String']>;
};

export type CreateInquiryResult = {
  __typename?: 'CreateInquiryResult';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CurrentAndIntendedMajors = {
  __typename?: 'CurrentAndIntendedMajors';
  majorCIPCode?: Maybe<Scalars['String']>;
  majorName?: Maybe<Scalars['String']>;
};

export type CurrentAndIntendedMajorsInput = {
  majorCIPCode?: InputMaybe<Scalars['String']>;
  majorName?: InputMaybe<Scalars['String']>;
};

export type CurrentEnrollments = {
  __typename?: 'CurrentEnrollments';
  ceebCode?: Maybe<Scalars['String']>;
  ncesCode?: Maybe<Scalars['String']>;
  schoolAddress?: Maybe<SchoolAddress>;
  schoolName?: Maybe<Scalars['String']>;
  schoolType?: Maybe<Scalars['String']>;
};

export type CurrentEnrollmentsInput = {
  ceebCode?: InputMaybe<Scalars['String']>;
  ncesCode?: InputMaybe<Scalars['String']>;
  schoolAddress?: InputMaybe<SchoolAddressInput>;
  schoolName?: InputMaybe<Scalars['String']>;
  schoolType?: InputMaybe<Scalars['String']>;
};

export type CurrentLocation = {
  __typename?: 'CurrentLocation';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type CurrentLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type Demographics = {
  __typename?: 'Demographics';
  /** @deprecated No longer storing sensitive data on the backend, this field's value will be ignored, refer to SensitiveCriteriaInput and its use in searchForScholarships */
  ancestry?: Maybe<Array<Scalars['String']>>;
  /** @deprecated No longer storing sensitive data on the backend, this field's value will be ignored, refer to SensitiveCriteriaInput and its use in searchForScholarships */
  ethnicity?: Maybe<Scalars['String']>;
  /** @deprecated No longer storing sensitive data on the backend, this field's value will be ignored, refer to SensitiveCriteriaInput and its use in searchForScholarships */
  gender?: Maybe<Scalars['String']>;
  /** @deprecated No longer storing sensitive data on the backend, this field's value will be ignored, refer to SensitiveCriteriaInput and its use in searchForScholarships */
  genderIdentity?: Maybe<Scalars['String']>;
  /** @deprecated No longer storing sensitive data on the backend, this field's value will be ignored, refer to SensitiveCriteriaInput and its use in searchForScholarships */
  race?: Maybe<Array<Scalars['String']>>;
};

export type DemographicsInput = {
  ancestry?: InputMaybe<Array<Scalars['String']>>;
  ethnicity?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  genderIdentity?: InputMaybe<Scalars['String']>;
  race?: InputMaybe<Array<Scalars['String']>>;
};

export type EligibilityCriteriaList = {
  __typename?: 'EligibilityCriteriaList';
  ecDescription?: Maybe<Scalars['String']>;
  ecName?: Maybe<Scalars['String']>;
};

export enum ExternalInquirySource {
  Email = 'email',
  Facebook = 'facebook',
  Slack = 'slack',
  Twilio = 'twilio',
  Web = 'web'
}

export type FafsaInfo = {
  __typename?: 'FafsaInfo';
  efcAmount?: Maybe<Scalars['Int']>;
  parentsAdjustedGrossIncomeAmount?: Maybe<Scalars['Int']>;
};

export type FafsaInfoInput = {
  efcAmount?: InputMaybe<Scalars['Int']>;
  parentsAdjustedGrossIncomeAmount?: InputMaybe<Scalars['Int']>;
};

export type GraduationInfo = {
  __typename?: 'GraduationInfo';
  graduated?: Maybe<Scalars['Boolean']>;
  graduationDate?: Maybe<Scalars['String']>;
  graduationStatus?: Maybe<Scalars['String']>;
  school?: Maybe<School>;
};

export type GraduationInfoInput = {
  graduated?: InputMaybe<Scalars['Boolean']>;
  graduationDate?: InputMaybe<Scalars['String']>;
  graduationStatus?: InputMaybe<Scalars['String']>;
  school?: InputMaybe<SchoolInput>;
};

export type Metadata = {
  __typename?: 'Metadata';
  created?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  numberOfScholarshipRecords?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type PermanentLocation = {
  __typename?: 'PermanentLocation';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type PermanentLocationInput = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
};

export type Profession = {
  __typename?: 'Profession';
  profession?: Maybe<Scalars['String']>;
  socCode?: Maybe<Scalars['String']>;
};

export type ProfessionInput = {
  profession?: InputMaybe<Scalars['String']>;
  socCode?: InputMaybe<Scalars['String']>;
};

export type RootMutation = {
  __typename?: 'RootMutation';
  createInquiry: CreateInquiryResult;
  searchForScholarships: ScholarshipResult;
  updateCriteria: UpdateCriteriaResult;
};


export type RootMutationCreateInquiryArgs = {
  externalId: Scalars['String'];
  externalSource: ExternalInquirySource;
  messageBody?: InputMaybe<Scalars['String']>;
};


export type RootMutationSearchForScholarshipsArgs = {
  scholarshipRecordId: Scalars['String'];
  sensitiveCriteria?: InputMaybe<SensitiveCriteriaInput>;
};


export type RootMutationUpdateCriteriaArgs = {
  input: ScholarshipCriteriaInput;
  scholarshipRecordId: Scalars['String'];
};

export type RootQuery = {
  __typename?: 'RootQuery';
  criteria?: Maybe<ScholarshipCriteria>;
  scholarships?: Maybe<ScholarshipResult>;
};


export type RootQueryCriteriaArgs = {
  scholarshipRecordId: Scalars['String'];
};


export type RootQueryScholarshipsArgs = {
  scholarshipRecordId: Scalars['String'];
};

export type ScholarshipCriteria = {
  __typename?: 'ScholarshipCriteria';
  academics?: Maybe<Academics>;
  activity?: Maybe<Array<Scalars['String']>>;
  affiliations?: Maybe<Array<Affiliations>>;
  age?: Maybe<Scalars['Int']>;
  /** @deprecated No longer storing sensitive data on the backend, this field's value will be ignored, refer to SensitiveCriteriaInput and its use in searchForScholarships */
  citizenshipStatuses?: Maybe<Array<Scalars['String']>>;
  collegeChoices?: Maybe<Array<CollegeChoices>>;
  collegeReadinessPrograms?: Maybe<Array<Scalars['String']>>;
  /** @deprecated No longer storing sensitive data on the backend, this field's value will be ignored, refer to SensitiveCriteriaInput and its use in searchForScholarships */
  condition?: Maybe<Array<Scalars['String']>>;
  currentAndIntendedMajors?: Maybe<Array<CurrentAndIntendedMajors>>;
  currentEnrollments?: Maybe<Array<CurrentEnrollments>>;
  currentGradeLevel?: Maybe<Scalars['String']>;
  currentLocation?: Maybe<CurrentLocation>;
  /** @deprecated No longer storing sensitive data on the backend, this field's value will be ignored, refer to SensitiveCriteriaInput and its use in searchForScholarships */
  demographics?: Maybe<Demographics>;
  enrollmentStatus?: Maybe<Array<Scalars['String']>>;
  fafsaInfo?: Maybe<FafsaInfo>;
  graduationInfo?: Maybe<GraduationInfo>;
  interests?: Maybe<Array<Scalars['String']>>;
  miscellaneous?: Maybe<Array<Scalars['String']>>;
  permanentLocation?: Maybe<PermanentLocation>;
  profession?: Maybe<Array<Profession>>;
  scholarshipPurpose?: Maybe<Scalars['String']>;
  situation?: Maybe<Array<Scalars['String']>>;
};

export type ScholarshipCriteriaInput = {
  academics?: InputMaybe<AcademicsInput>;
  activity?: InputMaybe<Array<Scalars['String']>>;
  affiliations?: InputMaybe<Array<AffiliationsInput>>;
  age?: InputMaybe<Scalars['Int']>;
  citizenshipStatuses?: InputMaybe<Array<Scalars['String']>>;
  collegeChoices?: InputMaybe<Array<CollegeChoicesInput>>;
  collegeReadinessPrograms?: InputMaybe<Array<Scalars['String']>>;
  condition?: InputMaybe<Array<Scalars['String']>>;
  currentAndIntendedMajors?: InputMaybe<Array<CurrentAndIntendedMajorsInput>>;
  currentEnrollments?: InputMaybe<Array<CurrentEnrollmentsInput>>;
  currentGradeLevel?: InputMaybe<Scalars['String']>;
  currentLocation?: InputMaybe<CurrentLocationInput>;
  demographics?: InputMaybe<DemographicsInput>;
  enrollmentStatus?: InputMaybe<Array<Scalars['String']>>;
  fafsaInfo?: InputMaybe<FafsaInfoInput>;
  graduationInfo?: InputMaybe<GraduationInfoInput>;
  interests?: InputMaybe<Array<Scalars['String']>>;
  miscellaneous?: InputMaybe<Array<Scalars['String']>>;
  permanentLocation?: InputMaybe<PermanentLocationInput>;
  profession?: InputMaybe<Array<ProfessionInput>>;
  scholarshipPurpose?: InputMaybe<Scalars['String']>;
  situation?: InputMaybe<Array<Scalars['String']>>;
};

export type ScholarshipDataCollection = {
  __typename?: 'ScholarshipDataCollection';
  applicationType?: Maybe<Scalars['String']>;
  applicationURL?: Maybe<Scalars['String']>;
  blurb?: Maybe<Scalars['String']>;
  closeDate?: Maybe<Scalars['String']>;
  eligibilityCriteriaDescription?: Maybe<Scalars['String']>;
  eligibilityCriteriaList?: Maybe<Array<EligibilityCriteriaList>>;
  enabled?: Maybe<Scalars['Boolean']>;
  isContest?: Maybe<Scalars['Boolean']>;
  isMeritBased?: Maybe<Scalars['Boolean']>;
  isNeedBased?: Maybe<Scalars['Boolean']>;
  lastVerifiedOn?: Maybe<Scalars['String']>;
  logoURL?: Maybe<Scalars['String']>;
  openDate?: Maybe<Scalars['String']>;
  programName?: Maybe<Scalars['String']>;
  programOrganizationName?: Maybe<Scalars['String']>;
  programReferenceId?: Maybe<Scalars['String']>;
  programURL?: Maybe<Scalars['String']>;
  scholarshipMaximumAward?: Maybe<Scalars['Int']>;
  scholarshipMinimumAward?: Maybe<Scalars['Int']>;
};

export type ScholarshipResult = {
  __typename?: 'ScholarshipResult';
  metadata?: Maybe<Metadata>;
  scholarshipDataCollection?: Maybe<Array<ScholarshipDataCollection>>;
};

export type School = {
  __typename?: 'School';
  ceebCode?: Maybe<Scalars['String']>;
  ncesCode?: Maybe<Scalars['String']>;
  schoolAddress?: Maybe<SchoolAddress>;
  schoolName?: Maybe<Scalars['String']>;
  schoolType?: Maybe<Scalars['String']>;
};

export type SchoolAddress = {
  __typename?: 'SchoolAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  stateOrProvince?: Maybe<Scalars['String']>;
  zipOrPostalCode?: Maybe<Scalars['String']>;
};

export type SchoolAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  stateOrProvince?: InputMaybe<Scalars['String']>;
  zipOrPostalCode?: InputMaybe<Scalars['String']>;
};

export type SchoolInput = {
  ceebCode?: InputMaybe<Scalars['String']>;
  ncesCode?: InputMaybe<Scalars['String']>;
  schoolAddress?: InputMaybe<SchoolAddressInput>;
  schoolName?: InputMaybe<Scalars['String']>;
  schoolType?: InputMaybe<Scalars['String']>;
};

export type SensitiveCriteriaInput = {
  ancestry?: InputMaybe<Array<Scalars['String']>>;
  citizenshipStatuses?: InputMaybe<Array<Scalars['String']>>;
  condition?: InputMaybe<Array<Scalars['String']>>;
  ethnicity?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  race?: InputMaybe<Array<Scalars['String']>>;
  sexuality?: InputMaybe<Scalars['String']>;
};

export type TestScores = {
  __typename?: 'TestScores';
  score?: Maybe<Scalars['Int']>;
  test?: Maybe<Scalars['String']>;
};

export type TestScoresInput = {
  score?: InputMaybe<Scalars['Int']>;
  test?: InputMaybe<Scalars['String']>;
};

export type UpdateCriteriaResult = {
  __typename?: 'UpdateCriteriaResult';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DemographicInfoFragment = { __typename?: 'ScholarshipCriteria', age?: number | null, citizenshipStatuses?: Array<string> | null, demographics?: { __typename?: 'Demographics', ancestry?: Array<string> | null, gender?: string | null, genderIdentity?: string | null, ethnicity?: string | null, race?: Array<string> | null } | null, currentLocation?: { __typename?: 'CurrentLocation', city?: string | null, county?: string | null, state?: string | null, country?: string | null } | null, permanentLocation?: { __typename?: 'PermanentLocation', city?: string | null, county?: string | null, state?: string | null, country?: string | null } | null };

export type AcademicInfoFragment = { __typename?: 'ScholarshipCriteria', currentGradeLevel?: string | null, activity?: Array<string> | null, interests?: Array<string> | null, academics?: { __typename?: 'Academics', cumulativeGPA?: number | null, classRankPercentile?: number | null, testScores?: Array<{ __typename?: 'TestScores', test?: string | null, score?: number | null }> | null } | null, graduationInfo?: { __typename?: 'GraduationInfo', graduated?: boolean | null, graduationDate?: string | null, graduationStatus?: string | null, school?: { __typename?: 'School', schoolName?: string | null, ncesCode?: string | null, ceebCode?: string | null, schoolType?: string | null, schoolAddress?: { __typename?: 'SchoolAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, country?: string | null } | null } | null } | null };

export type CollegeInfoFragment = { __typename?: 'ScholarshipCriteria', collegeReadinessPrograms?: Array<string> | null, enrollmentStatus?: Array<string> | null, scholarshipPurpose?: string | null, collegeChoices?: Array<{ __typename?: 'CollegeChoices', schoolName?: string | null, ncesCode?: string | null, ceebCode?: string | null, schoolType?: string | null, schoolAddress?: { __typename?: 'SchoolAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, country?: string | null } | null }> | null, currentEnrollments?: Array<{ __typename?: 'CurrentEnrollments', schoolName?: string | null, ncesCode?: string | null, ceebCode?: string | null, schoolType?: string | null, schoolAddress?: { __typename?: 'SchoolAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, country?: string | null } | null }> | null, currentAndIntendedMajors?: Array<{ __typename?: 'CurrentAndIntendedMajors', majorName?: string | null, majorCIPCode?: string | null }> | null };

export type AdditionalInfoFragment = { __typename?: 'ScholarshipCriteria', condition?: Array<string> | null, situation?: Array<string> | null, miscellaneous?: Array<string> | null, profession?: Array<{ __typename?: 'Profession', profession?: string | null, socCode?: string | null }> | null, affiliations?: Array<{ __typename?: 'Affiliations', entityName?: string | null, directRelation?: string | null, indirectRelation?: string | null }> | null };

export type GetCriteriaQueryVariables = Exact<{
  scholarshipRecordId: Scalars['String'];
}>;


export type GetCriteriaQuery = { __typename?: 'RootQuery', criteria?: { __typename?: 'ScholarshipCriteria', age?: number | null, citizenshipStatuses?: Array<string> | null, currentGradeLevel?: string | null, activity?: Array<string> | null, interests?: Array<string> | null, collegeReadinessPrograms?: Array<string> | null, enrollmentStatus?: Array<string> | null, scholarshipPurpose?: string | null, condition?: Array<string> | null, situation?: Array<string> | null, miscellaneous?: Array<string> | null, demographics?: { __typename?: 'Demographics', ancestry?: Array<string> | null, gender?: string | null, genderIdentity?: string | null, ethnicity?: string | null, race?: Array<string> | null } | null, currentLocation?: { __typename?: 'CurrentLocation', city?: string | null, county?: string | null, state?: string | null, country?: string | null } | null, permanentLocation?: { __typename?: 'PermanentLocation', city?: string | null, county?: string | null, state?: string | null, country?: string | null } | null, academics?: { __typename?: 'Academics', cumulativeGPA?: number | null, classRankPercentile?: number | null, testScores?: Array<{ __typename?: 'TestScores', test?: string | null, score?: number | null }> | null } | null, graduationInfo?: { __typename?: 'GraduationInfo', graduated?: boolean | null, graduationDate?: string | null, graduationStatus?: string | null, school?: { __typename?: 'School', schoolName?: string | null, ncesCode?: string | null, ceebCode?: string | null, schoolType?: string | null, schoolAddress?: { __typename?: 'SchoolAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, country?: string | null } | null } | null } | null, collegeChoices?: Array<{ __typename?: 'CollegeChoices', schoolName?: string | null, ncesCode?: string | null, ceebCode?: string | null, schoolType?: string | null, schoolAddress?: { __typename?: 'SchoolAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, country?: string | null } | null }> | null, currentEnrollments?: Array<{ __typename?: 'CurrentEnrollments', schoolName?: string | null, ncesCode?: string | null, ceebCode?: string | null, schoolType?: string | null, schoolAddress?: { __typename?: 'SchoolAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, country?: string | null } | null }> | null, currentAndIntendedMajors?: Array<{ __typename?: 'CurrentAndIntendedMajors', majorName?: string | null, majorCIPCode?: string | null }> | null, profession?: Array<{ __typename?: 'Profession', profession?: string | null, socCode?: string | null }> | null, affiliations?: Array<{ __typename?: 'Affiliations', entityName?: string | null, directRelation?: string | null, indirectRelation?: string | null }> | null } | null };

export type GetCriteriaAndResultsQueryQueryVariables = Exact<{
  scholarshipRecordId: Scalars['String'];
}>;


export type GetCriteriaAndResultsQueryQuery = { __typename?: 'RootQuery', scholarships?: { __typename?: 'ScholarshipResult', scholarshipDataCollection?: Array<{ __typename?: 'ScholarshipDataCollection', programReferenceId?: string | null, programOrganizationName?: string | null, programName?: string | null, programURL?: string | null, applicationURL?: string | null, openDate?: string | null, closeDate?: string | null, scholarshipMaximumAward?: number | null, scholarshipMinimumAward?: number | null, isNeedBased?: boolean | null, isMeritBased?: boolean | null, isContest?: boolean | null, blurb?: string | null, eligibilityCriteriaDescription?: string | null, lastVerifiedOn?: string | null, logoURL?: string | null, enabled?: boolean | null, applicationType?: string | null, eligibilityCriteriaList?: Array<{ __typename?: 'EligibilityCriteriaList', ecName?: string | null, ecDescription?: string | null }> | null }> | null, metadata?: { __typename?: 'Metadata', created?: string | null, message?: string | null, numberOfScholarshipRecords?: number | null, status?: string | null } | null } | null, criteria?: { __typename?: 'ScholarshipCriteria', age?: number | null, citizenshipStatuses?: Array<string> | null, currentGradeLevel?: string | null, activity?: Array<string> | null, interests?: Array<string> | null, collegeReadinessPrograms?: Array<string> | null, enrollmentStatus?: Array<string> | null, scholarshipPurpose?: string | null, condition?: Array<string> | null, situation?: Array<string> | null, miscellaneous?: Array<string> | null, demographics?: { __typename?: 'Demographics', ancestry?: Array<string> | null, gender?: string | null, genderIdentity?: string | null, ethnicity?: string | null, race?: Array<string> | null } | null, currentLocation?: { __typename?: 'CurrentLocation', city?: string | null, county?: string | null, state?: string | null, country?: string | null } | null, permanentLocation?: { __typename?: 'PermanentLocation', city?: string | null, county?: string | null, state?: string | null, country?: string | null } | null, academics?: { __typename?: 'Academics', cumulativeGPA?: number | null, classRankPercentile?: number | null, testScores?: Array<{ __typename?: 'TestScores', test?: string | null, score?: number | null }> | null } | null, graduationInfo?: { __typename?: 'GraduationInfo', graduated?: boolean | null, graduationDate?: string | null, graduationStatus?: string | null, school?: { __typename?: 'School', schoolName?: string | null, ncesCode?: string | null, ceebCode?: string | null, schoolType?: string | null, schoolAddress?: { __typename?: 'SchoolAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, country?: string | null } | null } | null } | null, collegeChoices?: Array<{ __typename?: 'CollegeChoices', schoolName?: string | null, ncesCode?: string | null, ceebCode?: string | null, schoolType?: string | null, schoolAddress?: { __typename?: 'SchoolAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, country?: string | null } | null }> | null, currentEnrollments?: Array<{ __typename?: 'CurrentEnrollments', schoolName?: string | null, ncesCode?: string | null, ceebCode?: string | null, schoolType?: string | null, schoolAddress?: { __typename?: 'SchoolAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, stateOrProvince?: string | null, zipOrPostalCode?: string | null, country?: string | null } | null }> | null, currentAndIntendedMajors?: Array<{ __typename?: 'CurrentAndIntendedMajors', majorName?: string | null, majorCIPCode?: string | null }> | null, profession?: Array<{ __typename?: 'Profession', profession?: string | null, socCode?: string | null }> | null, affiliations?: Array<{ __typename?: 'Affiliations', entityName?: string | null, directRelation?: string | null, indirectRelation?: string | null }> | null } | null };

export type GetScholarshipsQueryVariables = Exact<{
  scholarshipRecordId: Scalars['String'];
}>;


export type GetScholarshipsQuery = { __typename?: 'RootQuery', scholarships?: { __typename?: 'ScholarshipResult', scholarshipDataCollection?: Array<{ __typename?: 'ScholarshipDataCollection', programName?: string | null, programURL?: string | null }> | null } | null };

export type SearchForScholarshipsMutationVariables = Exact<{
  scholarshipRecordId: Scalars['String'];
  sensitiveCriteria?: InputMaybe<SensitiveCriteriaInput>;
}>;


export type SearchForScholarshipsMutation = { __typename?: 'RootMutation', searchForScholarships: { __typename?: 'ScholarshipResult', scholarshipDataCollection?: Array<{ __typename?: 'ScholarshipDataCollection', programName?: string | null, programURL?: string | null, programReferenceId?: string | null, programOrganizationName?: string | null, applicationURL?: string | null, openDate?: string | null, closeDate?: string | null, scholarshipMaximumAward?: number | null, scholarshipMinimumAward?: number | null, isNeedBased?: boolean | null, isMeritBased?: boolean | null, isContest?: boolean | null, blurb?: string | null, eligibilityCriteriaDescription?: string | null, lastVerifiedOn?: string | null, logoURL?: string | null, enabled?: boolean | null, applicationType?: string | null }> | null } };

export type UpdateCriteriaMutationVariables = Exact<{
  scholarshipRecordId: Scalars['String'];
  input: ScholarshipCriteriaInput;
}>;


export type UpdateCriteriaMutation = { __typename?: 'RootMutation', updateCriteria: { __typename?: 'UpdateCriteriaResult', success: boolean, message?: string | null } };

export const DemographicInfoFragmentDoc = gql`
    fragment demographicInfo on ScholarshipCriteria {
  age
  demographics {
    ancestry
    gender
    genderIdentity
    ethnicity
    race
  }
  currentLocation {
    city
    county
    state
    country
  }
  permanentLocation {
    city
    county
    state
    country
  }
  citizenshipStatuses
}
    `;
export const AcademicInfoFragmentDoc = gql`
    fragment academicInfo on ScholarshipCriteria {
  academics {
    testScores {
      test
      score
    }
    cumulativeGPA
    classRankPercentile
  }
  currentGradeLevel
  activity
  interests
  graduationInfo {
    graduated
    graduationDate
    graduationStatus
    school {
      schoolName
      ncesCode
      ceebCode
      schoolType
      schoolAddress {
        addressLine1
        addressLine2
        city
        stateOrProvince
        zipOrPostalCode
        country
      }
    }
  }
}
    `;
export const CollegeInfoFragmentDoc = gql`
    fragment collegeInfo on ScholarshipCriteria {
  collegeReadinessPrograms
  collegeChoices {
    schoolName
    ncesCode
    ceebCode
    schoolType
    schoolAddress {
      addressLine1
      addressLine2
      city
      stateOrProvince
      zipOrPostalCode
      country
    }
  }
  enrollmentStatus
  currentEnrollments {
    schoolName
    ncesCode
    ceebCode
    schoolType
    schoolAddress {
      addressLine1
      addressLine2
      city
      stateOrProvince
      zipOrPostalCode
      country
    }
  }
  currentAndIntendedMajors {
    majorName
    majorCIPCode
  }
  scholarshipPurpose
}
    `;
export const AdditionalInfoFragmentDoc = gql`
    fragment additionalInfo on ScholarshipCriteria {
  condition
  situation
  profession {
    profession
    socCode
  }
  miscellaneous
  affiliations {
    entityName
    directRelation
    indirectRelation
  }
}
    `;
export const GetCriteriaDocument = gql`
    query GetCriteria($scholarshipRecordId: String!) {
  criteria(scholarshipRecordId: $scholarshipRecordId) {
    ...demographicInfo
    ...academicInfo
    ...collegeInfo
    ...additionalInfo
  }
}
    ${DemographicInfoFragmentDoc}
${AcademicInfoFragmentDoc}
${CollegeInfoFragmentDoc}
${AdditionalInfoFragmentDoc}`;

/**
 * __useGetCriteriaQuery__
 *
 * To run a query within a React component, call `useGetCriteriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCriteriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCriteriaQuery({
 *   variables: {
 *      scholarshipRecordId: // value for 'scholarshipRecordId'
 *   },
 * });
 */
export function useGetCriteriaQuery(baseOptions: Apollo.QueryHookOptions<GetCriteriaQuery, GetCriteriaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCriteriaQuery, GetCriteriaQueryVariables>(GetCriteriaDocument, options);
      }
export function useGetCriteriaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCriteriaQuery, GetCriteriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCriteriaQuery, GetCriteriaQueryVariables>(GetCriteriaDocument, options);
        }
export type GetCriteriaQueryHookResult = ReturnType<typeof useGetCriteriaQuery>;
export type GetCriteriaLazyQueryHookResult = ReturnType<typeof useGetCriteriaLazyQuery>;
export type GetCriteriaQueryResult = Apollo.QueryResult<GetCriteriaQuery, GetCriteriaQueryVariables>;
export const GetCriteriaAndResultsQueryDocument = gql`
    query GetCriteriaAndResultsQuery($scholarshipRecordId: String!) {
  scholarships(scholarshipRecordId: $scholarshipRecordId) {
    scholarshipDataCollection {
      programReferenceId
      programOrganizationName
      programName
      programURL
      applicationURL
      openDate
      closeDate
      scholarshipMaximumAward
      scholarshipMinimumAward
      isNeedBased
      isMeritBased
      isContest
      blurb
      eligibilityCriteriaDescription
      lastVerifiedOn
      logoURL
      enabled
      applicationType
      eligibilityCriteriaList {
        ecName
        ecDescription
      }
    }
    metadata {
      created
      message
      numberOfScholarshipRecords
      status
    }
  }
  criteria(scholarshipRecordId: $scholarshipRecordId) {
    ...demographicInfo
    ...academicInfo
    ...collegeInfo
    ...additionalInfo
  }
}
    ${DemographicInfoFragmentDoc}
${AcademicInfoFragmentDoc}
${CollegeInfoFragmentDoc}
${AdditionalInfoFragmentDoc}`;

/**
 * __useGetCriteriaAndResultsQueryQuery__
 *
 * To run a query within a React component, call `useGetCriteriaAndResultsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCriteriaAndResultsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCriteriaAndResultsQueryQuery({
 *   variables: {
 *      scholarshipRecordId: // value for 'scholarshipRecordId'
 *   },
 * });
 */
export function useGetCriteriaAndResultsQueryQuery(baseOptions: Apollo.QueryHookOptions<GetCriteriaAndResultsQueryQuery, GetCriteriaAndResultsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCriteriaAndResultsQueryQuery, GetCriteriaAndResultsQueryQueryVariables>(GetCriteriaAndResultsQueryDocument, options);
      }
export function useGetCriteriaAndResultsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCriteriaAndResultsQueryQuery, GetCriteriaAndResultsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCriteriaAndResultsQueryQuery, GetCriteriaAndResultsQueryQueryVariables>(GetCriteriaAndResultsQueryDocument, options);
        }
export type GetCriteriaAndResultsQueryQueryHookResult = ReturnType<typeof useGetCriteriaAndResultsQueryQuery>;
export type GetCriteriaAndResultsQueryLazyQueryHookResult = ReturnType<typeof useGetCriteriaAndResultsQueryLazyQuery>;
export type GetCriteriaAndResultsQueryQueryResult = Apollo.QueryResult<GetCriteriaAndResultsQueryQuery, GetCriteriaAndResultsQueryQueryVariables>;
export const GetScholarshipsDocument = gql`
    query GetScholarships($scholarshipRecordId: String!) {
  scholarships(scholarshipRecordId: $scholarshipRecordId) {
    scholarshipDataCollection {
      programName
      programURL
    }
  }
}
    `;

/**
 * __useGetScholarshipsQuery__
 *
 * To run a query within a React component, call `useGetScholarshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScholarshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScholarshipsQuery({
 *   variables: {
 *      scholarshipRecordId: // value for 'scholarshipRecordId'
 *   },
 * });
 */
export function useGetScholarshipsQuery(baseOptions: Apollo.QueryHookOptions<GetScholarshipsQuery, GetScholarshipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScholarshipsQuery, GetScholarshipsQueryVariables>(GetScholarshipsDocument, options);
      }
export function useGetScholarshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScholarshipsQuery, GetScholarshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScholarshipsQuery, GetScholarshipsQueryVariables>(GetScholarshipsDocument, options);
        }
export type GetScholarshipsQueryHookResult = ReturnType<typeof useGetScholarshipsQuery>;
export type GetScholarshipsLazyQueryHookResult = ReturnType<typeof useGetScholarshipsLazyQuery>;
export type GetScholarshipsQueryResult = Apollo.QueryResult<GetScholarshipsQuery, GetScholarshipsQueryVariables>;
export const SearchForScholarshipsDocument = gql`
    mutation SearchForScholarships($scholarshipRecordId: String!, $sensitiveCriteria: SensitiveCriteriaInput) {
  searchForScholarships(
    scholarshipRecordId: $scholarshipRecordId
    sensitiveCriteria: $sensitiveCriteria
  ) {
    scholarshipDataCollection {
      programName
      programURL
      programReferenceId
      programOrganizationName
      applicationURL
      openDate
      closeDate
      scholarshipMaximumAward
      scholarshipMinimumAward
      isNeedBased
      isMeritBased
      isContest
      blurb
      eligibilityCriteriaDescription
      lastVerifiedOn
      logoURL
      enabled
      applicationType
    }
  }
}
    `;
export type SearchForScholarshipsMutationFn = Apollo.MutationFunction<SearchForScholarshipsMutation, SearchForScholarshipsMutationVariables>;

/**
 * __useSearchForScholarshipsMutation__
 *
 * To run a mutation, you first call `useSearchForScholarshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSearchForScholarshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [searchForScholarshipsMutation, { data, loading, error }] = useSearchForScholarshipsMutation({
 *   variables: {
 *      scholarshipRecordId: // value for 'scholarshipRecordId'
 *      sensitiveCriteria: // value for 'sensitiveCriteria'
 *   },
 * });
 */
export function useSearchForScholarshipsMutation(baseOptions?: Apollo.MutationHookOptions<SearchForScholarshipsMutation, SearchForScholarshipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SearchForScholarshipsMutation, SearchForScholarshipsMutationVariables>(SearchForScholarshipsDocument, options);
      }
export type SearchForScholarshipsMutationHookResult = ReturnType<typeof useSearchForScholarshipsMutation>;
export type SearchForScholarshipsMutationResult = Apollo.MutationResult<SearchForScholarshipsMutation>;
export type SearchForScholarshipsMutationOptions = Apollo.BaseMutationOptions<SearchForScholarshipsMutation, SearchForScholarshipsMutationVariables>;
export const UpdateCriteriaDocument = gql`
    mutation UpdateCriteria($scholarshipRecordId: String!, $input: ScholarshipCriteriaInput!) {
  updateCriteria(scholarshipRecordId: $scholarshipRecordId, input: $input) {
    success
    message
  }
}
    `;
export type UpdateCriteriaMutationFn = Apollo.MutationFunction<UpdateCriteriaMutation, UpdateCriteriaMutationVariables>;

/**
 * __useUpdateCriteriaMutation__
 *
 * To run a mutation, you first call `useUpdateCriteriaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCriteriaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCriteriaMutation, { data, loading, error }] = useUpdateCriteriaMutation({
 *   variables: {
 *      scholarshipRecordId: // value for 'scholarshipRecordId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCriteriaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCriteriaMutation, UpdateCriteriaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCriteriaMutation, UpdateCriteriaMutationVariables>(UpdateCriteriaDocument, options);
      }
export type UpdateCriteriaMutationHookResult = ReturnType<typeof useUpdateCriteriaMutation>;
export type UpdateCriteriaMutationResult = Apollo.MutationResult<UpdateCriteriaMutation>;
export type UpdateCriteriaMutationOptions = Apollo.BaseMutationOptions<UpdateCriteriaMutation, UpdateCriteriaMutationVariables>;